import { createRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ErrorLinesPage } from '@/features/runs/error-lines-page.js';
import { authenticatedRoute } from './authenticated.js';

/**
 * `/journal/runs/lignes-en-erreur` — les lignes du Suivi Martelet en erreur,
 * tous runs confondus (`02` §11). Page dédiée : c'est la cible des alertes
 * `fulfillment.line_failed` (`alerts/routes.ts`).
 *
 * Déclarée **avant** `/journal/runs/$type/$id` dans `router.tsx` : sans cela,
 * « lignes-en-erreur » serait pris pour un type de run.
 */
const errorLinesSearchSchema = z.object({
  page: z.coerce.number().int().min(1).optional(),
  sortBy: z.string().optional(),
  sortDir: z.enum(['asc', 'desc']).optional(),
  store: z.string().optional(),
  search: z.string().optional(),
});

export const journalErrorLinesRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/journal/runs/lignes-en-erreur',
  validateSearch: (search: Record<string, unknown>) => errorLinesSearchSchema.parse(search),
  component: ErrorLinesPage,
});
